import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { showNotification as showNotificationAction, refreshView as refreshViewAction } from 'admin-on-rest';
import restClient from '../restClient';

// Default "blacklist clicks from" date: start of the current month. Previous months are
// already invoiced, so a quick blacklist action should never silently reach back into one.
// Plain YYYY-MM-DD (native <input type="date">, not MUI's DatePicker) - a DatePicker's popup
// calendar can render behind an enclosing Dialog due to a z-index stacking conflict, making it
// unusable. See https://github.com/mui/mui-x/issues/10035 for the same class of issue.
const defaultFromDate = () => {
    const now = new Date();
    return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}-01`;
};

const styles = {
    link: { color: '#fd9512', cursor: 'pointer', display: 'block', padding: 3, border: '1px solid #fd9512', marginTop: 5, fontSize: 11, textAlign: 'center' },
};

class BlacklistQuickAction extends Component {
    state = { dialogOpen: false, loading: false, removeclicks_from: defaultFromDate() };

    openDialog = () => this.setState({ dialogOpen: true });
    closeDialog = () => this.setState({ dialogOpen: false });

    handleConfirm = () => {
        const { value, paramName, blacklistEndpoint, whitelistEndpoint, alreadyBlacklisted, refreshView, showNotification } = this.props;
        const { removeclicks_from } = this.state;

        this.setState({ loading: true });

        const endpoint = alreadyBlacklisted ? whitelistEndpoint : blacklistEndpoint;
        const data = { [paramName]: value };
        if (!alreadyBlacklisted) data.removeclicks_from = removeclicks_from;

        restClient('POST', endpoint, { data })
            .then(() => {
                this.setState({ loading: false, dialogOpen: false });
                refreshView();
            })
            .catch((e) => {
                console.error(e);
                showNotification((e && e.message) || 'Actie mislukt, probeer het opnieuw', 'warning');
                this.setState({ loading: false });
            });
    };

    render() {
        const { value, entityLabel, alreadyBlacklisted, durationNote } = this.props;
        const { dialogOpen, loading, removeclicks_from } = this.state;
        const btnLabel = alreadyBlacklisted ? `Whitelist ${entityLabel} + kliks` : `Blacklist ${entityLabel} + kliks`;

        return (
            <div>
                <span>{value}</span>
                <a style={styles.link} onClick={this.openDialog}>{btnLabel}</a>
                <Dialog
                    title={btnLabel}
                    modal={false}
                    open={dialogOpen}
                    onRequestClose={this.closeDialog}
                    actions={[
                        <FlatButton label="Annuleer" onClick={this.closeDialog} disabled={loading} />,
                        <RaisedButton label={loading ? 'Bezig...' : 'Bevestig'} primary style={{ marginLeft: 8 }} onClick={this.handleConfirm} disabled={loading} />,
                    ]}
                >
                    {alreadyBlacklisted ? (
                        <p>{entityLabel} <strong>{value}</strong> wordt van de blacklist gehaald. Kliks van de afgelopen 24 uur worden weer als geldig gemarkeerd.</p>
                    ) : (
                        <div>
                            <p>{entityLabel} <strong>{value}</strong> {durationNote}</p>
                            <p>
                                <strong>Kliks blacklisten vanaf:</strong> kies nooit een datum in een
                                al gefactureerde maand — standaard staat dit op de 1e van deze maand.
                            </p>
                            <TextField
                                type="date"
                                floatingLabelText="Vanaf datum"
                                fullWidth
                                value={removeclicks_from}
                                onChange={(_e, v) => this.setState({ removeclicks_from: v })}
                            />
                        </div>
                    )}
                </Dialog>
            </div>
        );
    }
}

export default connect(null, {
    showNotification: showNotificationAction,
    refreshView: refreshViewAction,
})(BlacklistQuickAction);



// WEBPACK FOOTER //
// ./src/utils/BlacklistQuickAction.js